import { Plus, Trash2, Wallet } from "lucide-react";
import { api, money } from "@/util";

export default function BankAccounts({ accounts, user, onNew, onChanged }) {
  const isManager = user?.role === "Yönetici";

  const totals = accounts.reduce((a, x) => a + (x.balance || 0), 0);

  const remove = async (id) => {
    if (!isManager) return;
    if (!window.confirm("Bu hesap silinsin mi?")) return;
    await api.delete(`/bank-accounts/${id}`);
    onChanged?.();
  };

  return (
    <section className="page-section">
      <div className="section-header">
        <div>
          <span className="eyebrow">BANKA HESAPLARI</span>
          <h2>Hesap bakiyeleri</h2>
          <p>Nakit, banka ve POS hesaplarının anlık bakiyelerini takip et.</p>
        </div>
        {isManager && (
          <button className="primary-button" onClick={() => onNew("bank")} data-testid="bank-add-button">
            <Plus size={17} /> Yeni hesap
          </button>
        )}
      </div>

      <div className="finance-summary">
        <div className="finance-chip positive" data-testid="accounts-total">
          <small>Toplam nakit</small><b>{money(totals)}</b>
        </div>
        <div className="finance-chip neutral" data-testid="accounts-count">
          <small>Hesap sayısı</small><b>{accounts.length}</b>
        </div>
      </div>

      {accounts.length ? (
        <div className="bank-grid">
          {accounts.map((a, idx) => (
            <article className={`bank-card ${a.type === "Kasa" ? "cash" : a.type === "Pos" ? "pos" : "bank"}`} key={a.id} data-testid={`bank-card-${idx}`}>
              <div className="bank-card-top">
                <div className="bank-icon"><Wallet size={16} /></div>
                <span className={`pill ${a.type === "Kasa" ? "warning" : "info"}`}>{a.type}</span>
                {isManager && (
                  <button className="icon-button small danger" onClick={() => remove(a.id)} data-testid={`bank-delete-${idx}`} title="Sil">
                    <Trash2 size={14} />
                  </button>
                )}
              </div>
              <h3>{a.name}</h3>
              <small className="muted">{a.iban || "—"}</small>
              <div className="bank-balance">
                <small>Bakiye</small>
                <b>{money(a.balance)}</b>
              </div>
            </article>
          ))}
        </div>
      ) : (
        <div className="empty-page">
          <div className="empty-icon"><Wallet size={24} /></div>
          <h2>Henüz hesap tanımlı değil</h2>
          <p>İlk banka ya da kasa hesabını ekle; finans hareketleri bakiyeni otomatik günceller.</p>
        </div>
      )}
    </section>
  );
}
